import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  ArrowRightLeft,
  Briefcase,
  X,
  FileText,
  ScrollText,
  BarChart3,
  FileCheck,
  Scale,
  MessageCircle,
} from 'lucide-react';
import clsx from 'clsx';
import Logo from '../common/Logo';
import { useAuth } from '../../context/AuthContext';

const navigationSections = [
  {
    title: 'ORIGINAÇÃO',
    roles: ['ADMIN', 'BANKER', 'TRADER', 'TESTER'],
    items: [
      {
        name: 'Leads',
        href: '/leads',
        icon: Users
      },
      {
        name: 'Conversas',
        href: '/atendimento/conversas',
        icon: MessageCircle
      },
      {
        name: 'Advogados',
        href: '/advogados-parceiros',
        icon: Scale
      }
    ]
  },
  {
    title: 'GESTÃO',
    roles: ['ADMIN', 'BANKER', 'TESTER'],
    items: [
      {
        name: 'Dashboard',
        href: '/',
        icon: LayoutDashboard
      },
      {
        name: 'Conversões',
        href: '/conversoes',
        icon: ArrowRightLeft
      },
      {
        name: 'Carteira',
        href: '/carteira',
        icon: Briefcase
      }
    ]
  },
  {
    title: 'MONITORAMENTO',
    roles: ['ADMIN', 'ANALYST', 'TESTER'],
    items: [
      {
        name: 'Dashboard',
        href: '/monitoramento',
        icon: BarChart3
      },
      {
        name: 'Publicações',
        href: '/publicacoes-dje',
        icon: FileCheck
      },
      {
        name: 'Processos',
        href: '/processos',
        icon: ScrollText
      }
    ]
  }
];

export default function Sidebar({ isOpen, onToggle }) {
  const location = useLocation();
  const { user } = useAuth();

  const filteredSections = navigationSections.filter(section => {
    if (section.roles) {
      return user && section.roles.includes(user.role);
    }
    return true;
  });


  return (
    <>
      {/* Mobile backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 z-20 lg:hidden"
          onClick={onToggle}
        />
      )}
      
      {/* Sidebar */}
      <div className={clsx(
        'fixed top-0 left-0 z-30 w-[225px] h-screen bg-white border-r border-gray-200 shadow-xl transform transition-transform duration-300 ease-in-out overflow-y-auto',
        'flex flex-col',
        'lg:translate-x-0 lg:static lg:h-screen',
        isOpen ? 'translate-x-0' : '-translate-x-full'
      )}>
        {/* Logo Section */}
        <div className="px-6 border-b border-gray-200 flex-shrink-0 h-16 flex items-center">
          <div className="flex items-center justify-between">
            <Logo />
            
            <button
              className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
              onClick={onToggle}
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-3">
          {filteredSections.map((section) => (
            <div key={section.title} className="mb-4">
              <div className="px-6 mb-2">
                <h3 className="text-xs font-bold text-gray-600 uppercase tracking-wider flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                  {section.title}
                </h3>
              </div>

              <ul className="space-y-0.5">
                {section.items.map((item) => {
                  const Icon = item.icon;
                  const isActive = location.pathname === item.href;

                  return (
                    <li key={item.name}>
                      <Link
                        to={item.href}
                        className={clsx(
                          'flex items-center px-6 py-2 text-gray-700 hover:text-gray-900 hover:bg-gray-50 transition-colors',
                          isActive && 'bg-blue-50 text-blue-700 border-r-4 border-blue-500'
                        )}
                        onClick={() => {
                          if (window.innerWidth < 1024) {
                            onToggle();
                          }
                        }}
                      >
                        <Icon className="w-5 h-5 mr-3" />
                        <span className="flex-1">{item.name}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </nav>
      </div>
    </>
  );
}